export default __webpack_public_path__ + "static/media/shankar-singh.ec38b24b.jpg";